(ns motorsaif.web.pages.settings.notifications
  (:require
   [motorsaif.string :refer [format]]
   [motorsaif.time :as time]
   [motorsaif.web.components :as c]
   [motorsaif.web.pwa :as pwa]
   [re-frame.core :as rf :refer [subscribe]]))

(defn push-subscription-card [{id :db/id
                               ua :client/ua
                               current :current
                               created :created}]
  (let [{:keys [browser os device]} ua
        os-family (:family os)
        device-family (:family device)]
    [:div.push-sub-card
     [:div.push-sub-header
      [:div.device-icon (case (:family browser)
                          "Firefox" [:i.fa-brands.fa-firefox]
                          "Chrome" [:i.fa-brands.fa-chrome]
                          "Safari" [:i.fa-brands.fa-safari]
                          "Edge" [:i.fa-brands.fa-edge]
                          [:i.fas.fa-globe])]
      [:div.browser-info
       [:h3 (str (:family browser) " " (:major browser) "." (:minor browser))]
       [:p.os-info (if (seq (:family os))
                     (str (:family os)
                          (when (seq (:major os)) (str " " (:major os))))
                     "Unknown OS")]]]
     [:div.push-sub-details
      [:p.subscription-date
       (format "Added on %s" (time/udt->format
                                 created
                                 "MMMM d yyyy"))]
      [:p.device-type
       (when current
         [:strong "Current Device "])

       (format "%s %s"
               os-family
               (if (= "Other" device-family)
                 "Desktop"
                 device-family))]]
     [:div.push-sub-actions
      [:button.delete-btn
       {:type :button
        :data-id id
        :on-click #(rf/dispatch [:delete-push-sub id])}
       [:i.fas.fa-trash-alt]
       "Remove"]]]))

(defn notifications-control
  ""
  []
  (let [has-other-clients? (seq @(rf/subscribe [:push-clients]))]
    (condp = (pwa/pushable-state)
      :can-push
      [:div.no-subscriptions
       [:h2.section-title "Not subscribed to push notifications"]
       [:p "You can receive push notifications on this device."]
       [:button.enable-btn
        {:on-click #(pwa/ask-enable-notifications)}
        [:i.fas.fa-bell]
        "Enable Notifications"]]

      :ios-install-app
      [:div.no-subscriptions
       [:h2.section-title "No Active Subscriptions"]
       [:p "Add app to home screen to receive push notifications"]]

      :fully-subbed
      [:div.no-subscriptions
       [:h2.section-title "Device Enabled"]
       [:p "You will receive push notifications from this device"]]
      [:div.no-subscriptions
       [:h2.section-title "No Active Subscriptions"]
       [:p "This browser does not support push notifications"]])))

(defn existing-clients []
  (let [clients @(rf/subscribe [:push-clients])
        sub-backend-id (pwa/sub-backend-id)]
    (when (seq clients)
      [:div.push-subscriptions
       [:h2.section-title "Active Push Notifications"]
       [:p.section-description "Below are the devices that will receive notifications from this site."]
       [:div.push-sub-list
        (for [{id :db/id :as client} clients]
          ^{:key id}
          [push-subscription-card
           (cond-> client
             (= sub-backend-id id)
             (assoc :current true))])]])))

(defn root []
  [:div.content
   [c/header "Notifications"]
   ^{:key (str
           (str @pwa/*push-sub)
           (count @(rf/subscribe [:push-clients])))}
   [:div.container.med
    {:user-id (:db/id @(subscribe [:user]))}
    [notifications-control]
    [existing-clients]]])
